import { makeStyles, Theme } from '@material-ui/core'
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../../../constants/colors'

const buildStyles = makeStyles((theme: Theme) => ({
  line: {
    textAlign: 'center',
  },
  firstLine1: {
    color: SECONDARY_COLOR,
    fontStyle: 'normal',
    fontWeight: 'bolder',
    fontSize: '60px',
  },
  firstLine2: {
    color: PRIMARY_COLOR,
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '30px',
  },
  secondLine: {
    color: '#000000',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '25px',
  },
}))

export default buildStyles
